import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FlowStatus } from '../types';

export interface UploadHistoryItem {
  id: string;
  flowId: string;
  timestamp: number;
  fileName: string;
  success: boolean;
  status: FlowStatus;
  completionPercentage?: number;
  completedFiles?: number;
  totalFiles?: number;
  errorMessage?: string;
}

interface UploadHistoryState {
  uploads: UploadHistoryItem[];
}

const initialState: UploadHistoryState = {
  uploads: []
};

const uploadHistorySlice = createSlice({
  name: 'uploadHistory',
  initialState,
  reducers: {
    addUpload: (state, action: PayloadAction<UploadHistoryItem>) => {
      // Add new upload to the beginning of the array (most recent first)
      state.uploads.unshift(action.payload);
    },
    updateUploadStatus: (state, action: PayloadAction<{
      flowId: string;
      status: FlowStatus;
      completionPercentage?: number;
      completedFiles?: number;
      totalFiles?: number;
      errorMessage?: string;
      success?: boolean;
    }>) => {
      const upload = state.uploads.find(u => u.flowId === action.payload.flowId);
      if (upload) {
        upload.status = action.payload.status;
        upload.completionPercentage = action.payload.completionPercentage;
        upload.completedFiles = action.payload.completedFiles;
        upload.totalFiles = action.payload.totalFiles;
        upload.errorMessage = action.payload.errorMessage;
        if (action.payload.success !== undefined) {
          upload.success = action.payload.success;
        }
      }
    },
    clearHistory: (state) => {
      state.uploads = [];
    },
    // Clean old uploads (older than 30 days)
    cleanOldUploads: (state) => {
      const thirtyDaysAgo = Date.now() - (30 * 24 * 60 * 60 * 1000);
      state.uploads = state.uploads.filter(upload => upload.timestamp > thirtyDaysAgo);
    }
  }
});

export const { addUpload, updateUploadStatus, clearHistory, cleanOldUploads } = uploadHistorySlice.actions;
export default uploadHistorySlice.reducer;